import { actions } from '../../utils/constants';

export const dismissNotification = (notification) => ({
    type: actions.DISMISS_NOTIFICATION,
    payload: notification,
});



// WEBPACK FOOTER //
// ./src/components/notifications/notifications.actions.js